import React from 'react';
import PropTypes from 'prop-types';
import Pficon from 'components/Pficon';
import classnames from 'classnames';
import { NODE_ICONS } from 'data/nodeTypes';
import {
  isAbGroup,
  isConjointGroup,
  isMaxDiffGroup,
  isVanWestendorpGroup,
} from 'utils/nodeTypes';
import QuestionFooter from 'containers/QuestionnairePage/GenericQuestion/QuestionFooter/index';
import Concepts from './AbTestViewOnly/index';
import Conjoint from '../../../QuestionnairePage/QuestionGroup/Conjoint';

const QuestionGroupViewOnly = (props) => {
  const { group, children, surveyId, hideActions } = props;

  const {
    refId,
    concepts,
    attributes,
    shuffle,
    type,
    goesToWithErrors = [],
    comesFrom = [],
    goesTo = [],
  } = group;

  const shuffleEnabled = shuffle > 0;
  const hasDisplayableSettings = Boolean(
    shuffleEnabled ||
    comesFrom.length ||
    goesTo.length ||
    goesToWithErrors.length,
  );

  const isAbType = isAbGroup(group.type);
  const isConjointType = isConjointGroup(group.type);
  const isMaxDiffType = isMaxDiffGroup(group.type);
  const isVanWestendorpType = isVanWestendorpGroup(group.type);
  const isProjectType =
    isAbType || isConjointType || isMaxDiffType || isVanWestendorpType;

  return (
    <div
      className={classnames(
        'questionnaire-group border-radius-level-1 margin-btm-md',
        {
          'background-projects-ab': isAbType,
          'background-projects-conjoint': isConjointType,
          'background-grey-3 border-grey-5': !isProjectType,
          'background-projects-vw': isVanWestendorpType,
          'background-projects-maxdiff': isMaxDiffType,
        },
      )}
    >
      <div className="flex-1 padding-top-md">
        <div className="flex flex-items-center margin-left-lg margin-btm-md text-size-h4">
          <Pficon
            type={NODE_ICONS[type]}
            className="text-base padding-vertical-xs"
          />
          <span className="margin-left-tiny">{group.label}</span>
        </div>
        <div
          className={classnames('padding-horizontal-lg', {
            'padding-btm-md': !hasDisplayableSettings,
          })}
        >
          {isAbType && (
            <Concepts
              refId={refId}
              concepts={concepts}
              attributes={attributes}
              surveyId={surveyId}
              isActive
              hideActions={hideActions}
            />
          )}
          {(isConjointType || isMaxDiffType) && (
            <Conjoint
              group={group}
              surveyId={surveyId}
              hideActions={hideActions}
            />
          )}
          {children}
        </div>
        <div className="padding-right-lg">
          {hasDisplayableSettings && (
            <QuestionFooter
              type={type}
              label={group.label}
              isGroup
              comesFrom={comesFrom}
              goesTo={goesTo}
              attributes={attributes}
              goesToWithErrors={goesToWithErrors}
              readOnly
              shuffle={group.shuffle}
            />
          )}
        </div>
      </div>
    </div>
  );
};
QuestionGroupViewOnly.propTypes = {
  group: PropTypes.object.isRequired,
  children: PropTypes.any,
  surveyId: PropTypes.string,
  hideActions: PropTypes.bool,
};

export default QuestionGroupViewOnly;
